<ng-template #approveModalTemplate>
  <div class="flex flex-col p-4">
    <div class="!pb-5 text-xl">{{ "domain-name" | translate }}</div>
    <app-contract-domain [contractId]="contractId" (closeForm)="submitedApproveForm()"></app-contract-domain>
  </div>
</ng-template>

<div class="panel mt-5">
  <div class="flex items-center justify-between">
    <h1 class="text-lg font-bold">
      {{ "instance.title" | translate }}
    </h1>
    <button type="button" class="btn btn-warning mr-2 rounded-full" (click)="approve()" *ngIf="!instance">Approve New Instance</button>
  </div>

  <section *ngIf="instance">
    <div class="grid grid-cols-2 gap-5">
      <div class="mb-5">
        <label>{{ "instance.front_end_domain" | translate }}</label>
        <p class="rounded-lg border-2 border-solid bg-gray-200 p-1 py-2">
          <a href="https://{{ instance.domainName }}" target="_blank">https://{{ instance.domainName }}</a>
        </p>
      </div>

      <div class="mb-5">
        <label>{{ "instance.back_end_domain" | translate }}</label>
        <p class="rounded-lg border-2 border-solid bg-gray-200 p-1 py-2">
          <a href="https://{{ instance.backendDomainName }}" target="_blank">https://{{ instance.backendDomainName }}</a>
        </p>
      </div>

      <div class="mb-5">
        <label>{{ "instance.start_date" | translate }}</label>
        <p class="rounded-lg border-2 border-solid bg-gray-200 p-1 py-2">
          {{ instance.startDate | date: "dd.MM.yyyy." }}
        </p>
      </div>

      <div class="mb-5">
        <label>{{ "instance.state" | translate }}</label>
        <p class="rounded-lg border-2 border-solid bg-gray-200 p-1 py-2">
          {{ instance.status }}
        </p>
      </div>

      <div class="mb-5">
        <label>{{ "instance.state_front_end" | translate }}</label>
        <p class="rounded-lg border-2 border-solid bg-gray-200 p-1 py-2">
          {{ "instance.active" | translate }}
        </p>
      </div>

      <div class="mb-5">
        <label>{{ "instance.state_back_end" | translate }}</label>
        <p class="rounded-lg border-2 border-solid bg-gray-200 p-1 py-2">
          {{ "instance.active" | translate }}
        </p>
      </div>
    </div>
  </section>
</div>
